import $ from 'jquery';
import { OffCanvas } from 'foundation-sites/js/foundation.offcanvas.js';
import {MediaQuery} from "foundation-sites/js/foundation.util.mediaQuery";

export default class SiteNavigation {
    init() {
        $(document).ready(() => {
            this.setupSelectors();
            this.setupEvents();
            this.setupFoundationModules();
        });
    }

    setupFoundationModules() {
        Foundation.plugin(OffCanvas, 'OffCanvas');
        this.$offCanvasNavigationMobile.foundation();
        this.$siteHeader.foundation();
    }

    setupSelectors()
    {
        this.$siteHeader = $('#site-header');
        this.$searchIcon = this.$siteHeader.find('.search-icon');
        this.$offCanvasNavigationMobile = $('#offCanvasNavigationMobile');
        this.$mainSiteSearch = $('#main-site-search');
    }

    setupEvents()
    {
        let me = this;

        $(window).on('changed.zf.mediaquery load', function () {
            SiteNavigation.addMarginBuffer();
            me.fixNavigationOnResize();
        });

        me.$mainSiteSearch.on('click', function(){
            window.dispatchEvent(new Event('searchShown'));
        });

        $(window).on("load resize",function(){
            if (MediaQuery.is('small only')) {
                me.$mainSiteSearch.attr("placeholder", "Search");
            } else {
                me.$mainSiteSearch.attr("placeholder", "What are you looking for today?");
            }
            $('.js-off-canvas-overlay').insertAfter('#offCanvasNavigationMobile');
        });

        me.$mainSiteSearch.on('focus', function(e){
            if (MediaQuery.is('small only')) {
                $(e.target).attr("placeholder", "Search");
            } else {
                $(e.target).attr("placeholder", "Search for a product or range");
            }
        });

        me.$siteHeader.on('mouseenter', '.is-dropdown-submenu-parent', function(e){
           me.handleMouseOver(e);
        });

        me.$siteHeader.on('mouseleave', '.is-dropdown-submenu-parent', function(e){
            $('.is-dropdown-submenu').hide();
        });

        me.$siteHeader.on('mouseleave', '.top-nav-menu', function(e){
            $('.site-overlay').fadeOut();
        });

        me.$siteHeader.on('open.zf.drilldown', '.drilldown', function(e) {
            //@TODO is there a better way to do this.
            //Handle New In click on mobile view
            if($(e.target).find('.New-In').attr('aria-expanded') == 'true') {
                $('.top-nav-menu').removeClass('invisible');
                window.location.href = "/category/new-in/";
            }

            //@TODO is there a better way to do this.
            //Handle changing header for expanded here.
            //HTML content has to be injected here because Foundation injects an HTML element that needs to contains this HTML
            let heading = $('.is-drilldown-submenu-parent[aria-expanded="true"]').data('title');
            let content = '<div class="mobile-menu-header hidden" style="display: flex;">' +
                '<img src="/media/ofl-responsive/icons/left-arrow.png" alt="Back" aria-hidden="true">' +
                '<span class="header-title">' + heading + '</span>' +
                '<a aria-label="Close menu" data-close="offCanvasNavigationMobile" role="menuitem" aria-expanded="true" aria-controls="offCanvasNavigationMobile" class="close-button">' +
                    '<img src="/media/ofl-responsive/icons/close.png" alt="Close">' +
                '</a>' +
                '</div>';

            $('.is-drilldown-submenu-parent[aria-expanded="true"]').find('.js-drilldown-back a').html(content);

            me.updateOffCanvasHeight();
        });

        me.$offCanvasNavigationMobile.find('.title.heading').on('click', function (e) {
            if ($(this).attr('submenu') === 'true') {
                e.preventDefault();
                $(this).parent().toggleClass('active-submenu');
                me.updateOffCanvasHeight();
            }
        });

        me.$offCanvasNavigationMobile.find('.close-button, .js-drilldown-back').on("click", function () {
            me.$offCanvasNavigationMobile.find('.is-drilldown').css("min-height", "0px");
        });
    }

    static calculateHeight() {
        return $('#sticky-header-content').outerHeight();
    }

    static addMarginBuffer() {
        if ($('#margin-buffer').length === 0) {
            $('#root').prepend('<div id="margin-buffer">&nbsp;</div>');
        }
        $('#margin-buffer').css('height', SiteNavigation.calculateHeight() + 'px');
    }

    handleMouseOver(element) {
        $('.is-dropdown-submenu').each(function() {
            $(this).hide();
            if ($(this).parent().hasClass($(element.target).text().replace(/\s/g, ""))) {
                $(this).show();
                $('.contentful-nav-item').hide();
                $('.site-overlay').fadeIn();
            } else if ($(this).parent().hasClass("New-In")) {
                $('.contentful-nav-item').show();
                $('.site-overlay').fadeIn();
            }
        });
    }

    fixNavigationOnResize() {
        let me = this;
        if (MediaQuery.is('medium down')) {
            me.$siteHeader.find('.title.heading').attr('submenu', 'true');
        } else {
            if (me.$offCanvasNavigationMobile.css('overflow-y') === 'hidden') {
                me.$offCanvasNavigationMobile.css('overflow-y', '');
            }
            me.$siteHeader.find('.title.heading').removeAttr('submenu');
        }
    }

    updateOffCanvasHeight() {
        let me = this;
        let height = $(".is-drilldown-submenu.is-active").prop("scrollHeight") || 0;
        me.$offCanvasNavigationMobile.find('.is-drilldown').css("min-height", `${height}px`);
    }
}
